/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const USER_COLUMNS = [
  { id: "name", label: "Name", accessorKey: "name", filterType: "text" },
  { id: "email", label: "Email", accessorKey: "email", filterType: "text" },
  { id: "role", label: "Roles", accessorKey: "role", filterType: "text" },
  { id: "department", label: "Department", accessorKey: "department", filterType: "text" },
  { id: "is_active", label: "Status", accessorKey: "is_active", filterType: "text" },
];

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const ROLE_COLUMNS = [
  { id: "name", label: "Name", accessorKey: "name", filterType: "text" },
  { id: "slug", label: "Slug", accessorKey: "slug", filterType: "text" },
  { id: "description", label: "Description", accessorKey: "description", filterType: "text" },
];
